import React, { useState, useEffect } from "react";

import { useParams } from "react-router-dom";
import {
  getLibraryDisplayName,
  libraryParams,
  normalizeLibraryCode,
} from "../../types/Library";

// 부산
import logo_busan_joongang_sujeong from "../../assets/images/logo/부산광역시중앙도서관_수정분관_web.png";
import logo_saha from "../../assets/images/logo/사하도서관_web.png";
import logo_busan_joongang from "../../assets/images/logo/부산광역시중앙도서관_web.png";
import logo_haeundae from "../../assets/images/logo/해운대도서관_web.png";

// 아산

import logo_꿈샘 from "../../assets/images/logo/꿈샘어린이청소년도서관_web.svg";
import logo_배방복합 from "../../assets/images/logo/배방복합커뮤니티센터_web.svg";
import logo_배방월천 from "../../assets/images/logo/배방월천도서관_web.svg";
import logo_음봉어울샘 from "../../assets/images/logo/아산음봉어울샘_web.svg";

export default function Header() {
  const { library } = useParams() as libraryParams;
  const defaultLogoSize = "w-56 qhd:w-80 tablet:w-48 mobile:w-32";
  const [logoImg, setLogoImg] = useState("");
  const [logoStyle, setLogoStyle] = useState(defaultLogoSize);
  const normalizedLibrary = normalizeLibraryCode(library);
  const title = getLibraryDisplayName(library);

  useEffect(() => {
    setLogoStyle(defaultLogoSize);

    switch (normalizedLibrary) {
      case "ak":
        setLogoImg(logo_busan_joongang);
        break;
      case "ah":
        setLogoImg(logo_busan_joongang_sujeong);
        setLogoStyle(`${defaultLogoSize}  mobile:h-5`);
        break;
      case "ae":
        setLogoImg(logo_saha);
        break;
      case "bd":
        setLogoImg(logo_haeundae);
        setLogoStyle(`${defaultLogoSize}  mobile:h-5`);
        break;
      case "kkoomsaem-lib":
        setLogoImg(logo_꿈샘);
        break;
      case "baebang-complex-lib":
        setLogoImg(logo_배방복합);
        setLogoStyle("w-[190px] qhd:w-80 tablet:w-[160px] mobile:w-[100px]");
        break;
      case "baebang-wolcheon-lib":
        setLogoImg(logo_배방월천);
        setLogoStyle("w-[280px] qhd:w-80 tablet:w-[260px] mobile:w-[160px]");
        break;
      case "eumbong-eoulsaem-lib":
        setLogoImg(logo_음봉어울샘);
        setLogoStyle("w-[280px] qhd:w-80 tablet:w-[260px] mobile:w-[160px]");
        break;
      default:
        setLogoImg("");
        break;
    }
  }, [normalizedLibrary]);

  return (
    <header className="flex items-center px-8 mobile:px-5">
      {logoImg ? (
        <img
          src={logoImg}
          alt={`${title} 로고`}
          className={logoStyle}
        />
      ) : (
        <h1 className="text-xl font-semibold text-slate-700 qhd:text-3xl tablet:text-lg mobile:text-sm">
          {title}
        </h1>
      )}
    </header>
  );
}
